import Vue from "vue";
import Vuex from "vuex";
import { db } from './main'
import { fbapp } from './main'
import firebase from "firebase";

Vue.use(Vuex);

export default new Vuex.Store({

  state: () => ({
    forsynID: [],
    user: null
  }),

  mutations: {
    ADD_TO_ID(state, ID) {
      this.state.forsynID.push(ID);
    },
    REMOVE_FROM_ID(state, item) {
      this.state.forsynID.splice(item, 1);
    },
    DELETE_ID(state){
      this.state.forsynID = [];
    },
    setUser: state => {
      state.user = firebase.auth().currentUser;
    }
  },

  actions: {
    setUser: context => {
      context.commit('setUser');
    }
  },

  getters: {                /* Getters are helper functions that retrieve data from our state. */
    forsynID: state => {
      return state.forsynID;
    },
    //https://www.freecodecamp.org/news/managing-user-state-with-vuex-firebase-77eebc64f546/ VUEX AUTH DEMO
    getUser: state => {
      return state.user;        // use it in any of our components by calling this.$store.getters.getUser;
    },
  }
});




// WEBPACK FOOTER //
// ./src/store.js